import { createAction } from '@reduxjs/toolkit';
import { notAvailable } from 'core/common/constants';
import { normalizeError } from 'core/common/errors';
import {
  ATTRS_ANALYTICS_FLOW_NAME,
  ATTRS_ANALYTICS_FUNNEL_LOCALE,
  ATTRS_ANALYTICS_FUNNEL_NAME,
  SpanName,
} from 'core/common/observability/entities';
import { AppThunk } from 'core/common/store';
import { PaymentMethod, PaymentType } from '../../entities';

export const updatePaymentType = createAction<PaymentType>('payments/UPDATE_PAYMENT_TYPE');
export const paymentMethodsSucceed = createAction<PaymentMethod>(
  'payments/PAYMENT_METHODS/succeed',
);

export const paymentMethodsRequest =
  (paymentId: string): AppThunk<Promise<PaymentMethod | null>> =>
  async (dispatch, _, context) => {
    const {
      loggingService: logger,
      observabilitySystem,
      errorMonitoringService,
      paymentService,
      funnelSettingsService,
    } = context;

    const spanAttributes = {
      [ATTRS_ANALYTICS_FUNNEL_NAME]: funnelSettingsService.getFunnelName(),
      [ATTRS_ANALYTICS_FLOW_NAME]: funnelSettingsService.getFlowName(),
      [ATTRS_ANALYTICS_FUNNEL_LOCALE]: funnelSettingsService.getFunnelLocale(),
    };

    const span = observabilitySystem.startSpan(SpanName.PAYMENT_METHODS_REQUEST);
    span.setAttributes(spanAttributes);

    try {
      const paymentMethod = await paymentService.getPaymentMethods(paymentId);

      dispatch(paymentMethodsSucceed(paymentMethod));
      span.succeed();

      return paymentMethod;
    } catch (err) {
      const error = normalizeError(err);

      span.fail(error);
      logger.error(error);

      errorMonitoringService.captureError(error, {
        tags: {
          get_params: location.search || notAvailable,
          error_message: error.message,
          error_reason: 'payment_methods_request_failed',
          funnel_name: funnelSettingsService.getFunnelName(),
        },
      });

      return null;
    }
  };
